import { useState, useCallback, useRef, useLayoutEffect } from "react";

const useThereIsMoreToScroll = (offset = 100, deps = []) => {
    const scrollRef = useRef(null);
    const [thereIsMore, setThereIsMore] = useState(false);

    const handleShowIsMore = useCallback((node) => {
        if (node !== null) {
            const isScrollable =
                node.scrollHeight - node.scrollTop - offset >=
                node.clientHeight;
            setThereIsMore(isScrollable);
        }
    }, []);

    useLayoutEffect(() => {
        handleShowIsMore(scrollRef.current);
    }, deps);

    const handleScroll = (e) => {
        if (e !== undefined) handleShowIsMore(e.target);
    };

    return { thereIsMore, scrollRef, handleScroll };
};

export default useThereIsMoreToScroll;
